import { render, staticRenderFns } from "./EncouragePlan.vue?vue&type=template&id=5752cd64&scoped=true"
import script from "./EncouragePlan.vue?vue&type=script&lang=js"
export * from "./EncouragePlan.vue?vue&type=script&lang=js"
import style0 from "./EncouragePlan.vue?vue&type=style&index=0&id=5752cd64&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5752cd64",
  null
  
)

export default component.exports